document.addEventListener('DOMContentLoaded', () => {
  const searchInput = document.getElementById("faqSearchInput");
  const faqItems = [...document.querySelectorAll(".faq-section__blocks-grid")];
  const categoryButtons = document.querySelectorAll('.faq-section__categories-btn');
  const headerHeight = document.querySelector('.main-header-top')?.offsetHeight || 0;
  const nothingFoundMessage = document.createElement('p');

  nothingFoundMessage.className = 'nothing-found';
  nothingFoundMessage.textContent = 'Nothing found.';
  nothingFoundMessage.style.display = 'none';
  document.querySelector('.faq-section__content')?.appendChild(nothingFoundMessage);

  const stripHighlights = (el) => {
    if (!el) return;
    el.innerHTML = el.innerHTML.replace(/<span class="highlight">(.*?)<\/span>/g, "$1");
  };

  const highlightMatches = (el, searchTerm) => {
    const text = el.textContent;
    const regex = new RegExp(`(${searchTerm})`, 'gi');
    const newHtml = text.replace(regex, '<span class="highlight">$1</span>');
    if (newHtml !== el.innerHTML) el.innerHTML = newHtml;
  };

  const throttle = (func, delay) => {
    let timeout;
    return (...args) => {
      clearTimeout(timeout);
      timeout = setTimeout(() => func.apply(this, args), delay);
    };
  };

  const handleSearch = () => {
    const searchTerm = searchInput.value.trim().toLowerCase();
    let foundAny = false;

    faqItems.forEach(item => {
      const title = item.querySelector(".faq-section__blocks-benefits__title");
      const description = item.querySelector(".faq-section__blocks-benefits__description");

      stripHighlights(title);
      stripHighlights(description);

      const titleText = title?.textContent?.toLowerCase() || '';
      const descriptionText = description?.textContent?.toLowerCase() || '';

      if (!searchTerm || titleText.includes(searchTerm) || descriptionText.includes(searchTerm)) {
        item.style.display = '';
        if (searchTerm) {
          highlightMatches(title, searchTerm);
          highlightMatches(description, searchTerm);
        }
        foundAny = true;
      } else {
        item.style.display = 'none';
      }
    });

    document.querySelectorAll('.faq-section__group').forEach(group => {
      const visibleItems = group.querySelectorAll('.faq-section__blocks-grid:not([style*="display: none"])');
      const categoryTitle = group.previousElementSibling;

      const isVisible = visibleItems.length > 0;
      group.style.display = isVisible ? '' : 'none';
      if (categoryTitle && categoryTitle.classList.contains('faq-section__category-title')) {
        categoryTitle.style.display = isVisible ? '' : 'none';
      }
    });

    nothingFoundMessage.style.display = foundAny ? 'none' : 'block';
  };

  const handleCategoryClick = (event) => {
    event.preventDefault();
    const category = event.currentTarget.getAttribute('data-category');

    categoryButtons.forEach(btn => btn.classList.remove('active'));
    event.currentTarget.classList.add('active');

    if (category === 'all') {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    } else {
      const targetGroup = document.querySelector(`#category-${category}`);
      if (targetGroup) {
        const targetPosition = targetGroup.getBoundingClientRect().top + window.scrollY - headerHeight;
        window.scrollTo({ top: targetPosition, behavior: 'smooth' });
      }
    }
  };

  // throttle input: only run search 300ms after user stops typing
  searchInput.addEventListener("input", throttle(handleSearch, 300));

  if (categoryButtons.length > 0) {
    categoryButtons[0].classList.add('active');
  }

  categoryButtons.forEach(button => {
    button.addEventListener('click', handleCategoryClick);
  });
});
